import React from "react";

const SupplierTariffDetails = ({ supplierName, tariffName }) => {
  return (
    <div className="mt-4">
      <h4 className="text-md font-bold leading-[1.5]">{supplierName}</h4>
      <p>{tariffName}</p>
    </div>
  );
};

export default SupplierTariffDetails;
